<!-- Loading resources -->
<div *ngIf="isLoading; else ratingsGrid">
  <div class="guts-p-t-1-half">
    <dgx-skeleton type="mediumTitle"></dgx-skeleton>
    <div class="l_flex">
      <dgx-skeleton
        type="horizontalBlock"
        class="grid__col-md-4 guts-p-l-0 m-guts-p-v-1-half m-guts-p-r-0"
      ></dgx-skeleton>
      <dgx-skeleton
        type="horizontalBlock"
        class="grid__col-md-4 no-mobile"
      ></dgx-skeleton>
      <dgx-skeleton
        type="horizontalBlock"
        class="grid__col-md-4 no-mobile guts-p-r-0"
      ></dgx-skeleton>
    </div>
  </div>
</div>

<!-- Ratings -->
<ng-template #ratingsGrid>
  <!-- Header -->
  <div class="l_flex l_flex-center-children guts-m-b-1">
    <h3 class="h3">
      {{ 'Core_Ratings' | translate }}
    </h3>
    <df-icon
      *ngIf="!ownerIsViewing"
      [ngbTooltip]="i18n.dgSkillSignalRatings_PrivacyInfo"
      icon="info"
      size="small"
      [a11yText]="i18n.dgSkillSignalRatings_PrivacyInfo"
      class="color-ebony-a61 guts-m-l-1"
    ></df-icon>
  </div>

  <!-- Grid -->
  <dgx-profile-card-carousel>
    <div
      class="l_flex m-l_flex full-width l_flex-justify"
      [ngClass]="{ 'l_flex-wrap': !isMobile }"
    >
      <div
        *ngFor="
          let type of sortedRatings.slice(0, numRatingsLimit);
          trackBy: trackByFn
        "
        data-dgat="skill-signal-ratings-a75"
      >
        <div class="l_flex m-l_flex l_flex-column rating-tile m-guts-m-r-3">
          <!--Rating buttons-->
          <ng-template #ratingButton>
            <div class="tile__flex" #ratingCard tabindex="0">
              <dgx-tag-rating-button
                [type]="type"
                [ownerIsViewing]="ownerIsViewing"
                [tag]="tag"
                [tagRatingDetails]="tagRatingDetails"
                [availableRatingTypes]="availableRatings"
                [trackingLocation]="trackingLocation"
                [allCheckpoints]="allCheckpoints"
                [isEvaluable]="isTagEvaluable"
              ></dgx-tag-rating-button>
            </div>
          </ng-template>

          <!-- Empty Block -->
          <ng-container
            *ngIf="type === 'Empty'; else ratingButton"
            data-dgat="skill-signal-ratings-eeb"
          >
            <div class="profile-empty__tile"></div
            >
          </ng-container>
        </div>
      </div>
    </div>
  </dgx-profile-card-carousel>

  <!-- Show more button -->
  <div
    *ngIf="sortedRatings.length > numRatingsLimit"
    class="center-text no-mobile"
  >
    <button
      df-button
      dfButtonType="passive"
      class="show-more-btn"
      (click)="loadMoreRatings()"
      data-dgat="skill-signal-ratings-82a"
    >
      {{ 'Core_ShowMore' | translate }}
    </button>
  </div>
</ng-template>
